<template>
  <div class="base">
    <inside-header color="#fff" title="邮箱设置" />
    <div class="main">
      <div v-if="step === 'first'" class="first-step">
        <a-alert message="您好，您正在绑定邮箱。平台将向您输入的邮箱发送验证链接和验证码，如需立即验证请在下列表单中下一步填写邮箱中的验证码" banner />
        <a-form :form="emailForm" :label-col="{ span: 5 }" style="margin-top: 40px;" :wrapper-col="{ span: 18 }"
          @submit="handleSubmitEmailBind">
          <a-form-item label="邮箱地址">
            <a-input v-decorator="[
              'email',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入您的邮箱',
                  },
                  {
                    type: 'email',
                    message: '请输入正确的邮箱地址'
                  }
                ],
              },
            ]" placeholder="输入您的邮箱" />
          </a-form-item>
          <a-form-item label="验证码">
            <a-row :gutter="16">
              <a-col :span="16">
                <a-input v-decorator="[
                  'captcha_value',
                  { rules: [{ required: true, message: '请输入图形验证码' }] },
                ]" size="large" placeholder="图形验证码" />
              </a-col>
              <a-col :span="8">
                <img style="cursor: pointer" width="80px" height="100%" :src="captcha_img_str" alt=""
                  @click="loadVerify">
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" :loading="state.changeEmailBtn" html-type="submit">
              下一步
            </a-button>
          </a-form-item>
        </a-form>
      </div>
      <div v-if="step === 'second'" class="second-step">
        <a-alert message="查收平台下发邮箱的邮件，将验证码复制到输入框进行验证" banner />
        <a-form :form="emailVerifyForm" :label-col="{ span: 5 }" style="margin-top: 40px;" :wrapper-col="{ span: 18 }"
          @submit="handleSubmitEmailVerify">
          <a-form-item label="验证码">
            <a-input v-decorator="[
              'bind_email_token',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入您的邮箱验证码',
                  }
                ],
              },
            ]" placeholder="输入您的邮箱验证码" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" :loading="state.verifyEmailBtn" html-type="submit">
              提交
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'

export default {
  name: 'UserSetting',
  components: {
    MainFooter,
    InsideHeader
  },
  data() {
    return {
      loading: false,
      state: {
        changeEmailBtn: false
      },
      // 验证码
      captcha_key: '',
      captcha_img_str: '',
      // 邮箱相关
      emailForm: this.$form.createForm(this, { name: 'email-form' }),
      emailVerifyForm: this.$form.createForm(this, { name: 'email-verify-form' }),
      // 当前步骤
      step: 'first'
    }
  },
  created() {
    this.loadVerify()
  },
  methods: {
    loadVerify() {
      // 调用删除
      this.$http({
        url: '/index/index/captcha',
        method: 'get'
      }).then(res => {
        if (res.status === 'success') {
          this.captcha_key = res.data.captcha_key
          this.captcha_img_str = res.data.img_str
        } else {
          this.$notification.error({
            message: '错误',
            description: '获取验证码失败'
          })
        }
      })
    },
    handleSubmitEmailBind(e) {
      e.preventDefault()
      this.emailForm.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.state.changeEmailBtn = true
          values.captcha_key = this.captcha_key
          this.$http({
            url: '/index/user/bindEmail',
            method: 'post',
            data: values
          }).then(res => {
            this.state.changeEmailBtn = false
            if (res.status === 'success') {
              this.$toast.success('发送邮件成功，请及时查收')
              this.step = 'second'
            } else {
              this.$toast.fail(res.message)
            }
          })
        }
      })
    },
    handleSubmitEmailVerify(e) {
      e.preventDefault()
      this.emailVerifyForm.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.state.verifyEmailBtn = true
          this.$http({
            url: '/index/user/activeEmail',
            method: 'get',
            params: {
              bind_email_token: values.bind_email_token
            }
          }).then(res => {
            this.state.verifyEmailBtn = false
            if (res.status === 'success') {
              this.$toast.success('绑定邮箱成功')
              // 刷新当前页面
              const that = this
              setTimeout(function () {
                that.$router.push({ name: 'UserSetting' })
              }, 2000)
            } else {
              this.$toast.fail(res.message)
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .main {
    padding: 15px;
  }

  .logout-btn {
    margin-top: 20px;
    .van-button__content {
      span {
        color: #333333;
      }
    }
  }

  .submit-area {
    margin-top: 35px;
    .submit-btn {
      border-radius: 10px;
    }
  }
</style>
